// AUTHORITATIVE zh-Hans — OWNED BY SCORER (PL #8378). CF-ZH-L10N-V1 + Dragon/Tiger relabel + tier themes.
// HAND-MAINTAINED. ⛔ Do NOT run scripts/gen-i18n.mjs against this file — see en.ts header.
//    Historical origin: the Scorer zh keytable — inventory only, not a source.
import type { Dict } from './core';

export const zh: Dict = {
  'common.ton_unit': 'TON',
  'common.done_btn': '完成',
  'common.close_btn': '关闭',
  'common.cancel_btn': '取消',
  'common.retry_btn': '重试',
  'common.heads': '龙',
  'common.tails': '虎',
  'common.back_to_cricketflip': '← 返回 CricketFlip',
  'app.brand_name': 'CricketFlip',
  'app.beta.badge': '已上线 — 私人测试版',
  'app.beta.tagline': '标准档获胜赔付 2×。每一局都可验证。',
  'app.beta.invite_only': '我们还在完成安全加固，目前仅限受邀访问。',
  'app.beta.notify_btn': '接收上线通知',
  'app.beta.follow_note': '关注 @cricketflip_official 获取上线公告',
  'app.browser_gate.tagline': 'TON 龙虎斗 · 即时派奖',
  'app.browser_gate.subtagline': '标准档获胜赔付 2×。每一局都可用 HMAC 验证。',
  'app.browser_gate.play_btn': '在 Telegram 中玩',
  'app.browser_gate.exclusive_note': '仅作为 Telegram Mini App 提供',
  'app.header.subtitle': '可验证公平 · 可自行核验',
  'app.header.connect_wallet_btn': '连接钱包',
  'app.wallet.connected_label': '已连接',
  'app.wallet.onchain_balance_label': '钱包余额',
  'app.wallet.address_label': '钱包地址',
  'app.wallet.ingame_balance_label': '现金余额',
  'app.wallet.withdraw_btn': '💎 提取现金 · {amount} TON',
  'app.wallet.balance_unavailable': '暂时无法显示',
  'app.wallet.checking_session': '⏳ 正在检查会话...',
  'app.wallet.switch_btn': '切换',
  'app.wallet.disconnect_btn': '断开连接',
  'app.nav.flip': '下注',
  'app.nav.activity': '记录',
  'app.nav.leaders': '排行',
  'app.nav.verify': '验证',
  'app.switch_warning.switch_title': '切换钱包？',
  'app.switch_warning.disconnect_title': '断开钱包？',
  'app.switch_warning.has_funds_body': '你的 {amount} TON 余额保存在你的CricketFlip账户中。提现会处理到你当前绑定的钱包 — 请先提现到这个钱包，或之后重新连接同一个钱包。',
  'app.switch_warning.unknown_balance_body': '我们现在无法确认你的CricketFlip余额。如果账户里有资金，它们仍会保留在你的账户中；重新连接即可访问。',
  'app.switch_warning.withdraw_first_btn': '先提现',
  'app.switch_warning.switch_anyway_btn': '仍要切换',
  'app.switch_warning.disconnect_anyway_btn': '仍要断开',
  'boost.tier_selected_aria': '已选择 {label}；点击可恢复为标准档',
  'boost.tier_select_aria': '选择 {label} 档位；赢局 +{pct}%，每质押 1 TON 收取 {fee} TON 费用',
  'boost.tier_label_pct': '{LABEL} +{pct}%',
  'boost.tier_fee_per_ton': '费用 {fee} / TON',
  'coinflip.toast.not_enough_practice': '练习币不足！',
  'coinflip.toast.balance_updating': '你的余额正在更新 — 请稍后再试。',
  'coinflip.toast.chain_exhausted': '所有种子都在处理中 — 请稍后再试。',
  'coinflip.toast.service_busy': '服务繁忙 — 请稍后重试。',
  'coinflip.toast.commit_failed': '无法开始本局。请重试。',
  'coinflip.toast.no_secure_random': '你的浏览器不支持安全随机数。请使用现代浏览器。',
  'coinflip.toast.flip_in_flight': '上一局仍在结算 — 请稍等片刻再试。',
  'coinflip.toast.commit_expired': '承诺已过期 — 请再次点击「下注」获取新的承诺。',
  'coinflip.toast.request_conflict': '请求冲突 — 请重试。',
  'coinflip.toast.insufficient_balance': '余额不足，无法下这个注额。',
  'coinflip.toast.stake_out_of_range': '注额超出允许范围。请选择更小的筹码。',
  'coinflip.toast.maintenance': '下注功能正在维护，暂时暂停。请几分钟后再试。',
  'coinflip.toast.hot_wallet_unconfigured': '下注功能正在配置中 — 请稍后再试。',
  'coinflip.toast.hot_wallet_balance_unavailable': '网络短暂波动 — 请再次点击「下注」。你的余额安全。',
  'coinflip.toast.insolvency_protection': '服务器正在平衡风险敞口 — 请稍后再次点击「下注」。',
  'coinflip.toast.flip_failed_safe': '本局未能完成。你的余额安全 — 请重试。',
  'coinflip.toast.failed_refunded': '本局结算失败；你的注额已退回。',
  'coinflip.toast.flip_incomplete': '本局未能完成。',
  'coinflip.toast.unexpected_response': '服务器响应异常。请重试。',
  'coinflip.toast.connection_error': '连接错误。请重试。',
  'coinflip.toast.something_wrong': '出了点问题。请重试。',
  'coinflip.toast.deposit_confirmed': '充值已确认！可以开始下注',
  'coinflip.flipping': '开牌中...',
  'coinflip.result.you_won': '你赢了',
  'coinflip.currency.credits': '练习币',
  'coinflip.result.win_detail': '{OUTCOME} · {betAmount} {currency} × {mult}x',
  'coinflip.result.you_picked': '你选择了{choice}',
  'coinflip.result.loss_amount': '-{gross} {currency}',
  'coinflip.base_summary_bet': '下注',
  'coinflip.base_summary_win': '赢取',
  'coinflip.provably_fair_tagline': '每一局都可验证公平',
  'coinflip.choose_again_btn': '重新选择',
  'coinflip.verify_btn': '✅ 验证',
  'coinflip.loading_session': '正在加载你的会话…',
  'coinflip.connecting': '正在连接…',
  'coinflip.deposit_to_play_btn': '充值后开始',
  'coinflip.withdraw_btn': '提现',
  'coinflip.add_funds_btn': '+ 充值',
  'coinflip.practice_mode_banner': '免费试玩 · 准备好即可赢真实 TON',
  'coinflip.tap_to_flip_hero': '点击开牌',
  'coinflip.tap_to_flip_aria': '点击进行免费开牌',
  'coinflip.now_pick_side': '现在选择龙或虎',
  'coinflip.demo_upsell_title': '喜欢这个游戏？用真实 TON 来玩。',
  'coinflip.demo_upsell_sub': '同样玩法。真实奖金。随时提现。',
  'coinflip.connect_wallet_deposit_btn': '💎 连接钱包并充值',
  'coinflip.wallet_connected_banner': '钱包已连接！充值 TON 即可玩真钱模式。',
  'coinflip.deposit_ton_btn': '💎 充值 TON',
  'coinflip.keep_demo_hint': '或继续在下方使用演示模式 ↓',
  'coinflip.pick_heads_aria': '选择龙',
  'coinflip.pick_tails_aria': '选择虎',
  'coinflip.pick_side_prompt': '选择龙或虎',
  'coinflip.chip.insufficient_for_tier': '余额不足，无法支付当前档位的注额 + 费用',
  'coinflip.chip.house_coverage_low': '当前庄家覆盖不足，暂时无法接受此下注',
  'coinflip.flip_btn_pick_side': '请选择龙或虎',
  'coinflip.flip_btn_demo': '试玩下注 {stake} {currency}',
  'coinflip.flip_disabled.insufficient': '余额不足，无法下此注 — 请选择更小的筹码或充值更多。',
  'coinflip.flip_disabled.tier_fee_exceeds': '黄金/钻石会收取费用 — 总成本 {gross} TON 超过你的余额。请选择更小的筹码、切换到标准档，或充值更多。',
  'coinflip.flip_disabled.limit_unavailable': '当前无法获取下注限额 — 请稍等片刻后重试。',
  'coinflip.pf_button_verifiable': '每个结果都可验证 — 我们公开计算方式',
  'coinflip.pf_button_free_demo': '🎮 免费演示 · 无需钱包 · 随时可玩真钱模式',
  'coinflip.info.title': 'CricketFlip有何不同',
  'coinflip.info.subtitle': '为玩家而建，而不是针对玩家',
  'coinflip.info.custody_title': '你的余额由托管账户保管',
  'coinflip.info.custody_body': '充值时，你的 TON 会转入CricketFlip运营的热钱包，你的余额会记录在我们的账本中。你可以随时提现到绑定钱包 — 链上转账由我们处理。',
  'coinflip.info.locked_title': '你下注前，结果已经被锁定',
  'coinflip.info.locked_body': '每一局下注前，我们都会先发布 commit_hash（新 server_seed 的 SHA-256）。你的浏览器会发送自己的 client_seed。结算后我们公开 server_seed；你可以重新计算 SHA-256 和 HMAC，亲自检查结果。',
  'coinflip.info.withdraw_title': '随时提现。全额余额。',
  'coinflip.info.withdraw_body': '轻点一次，你的全部余额就会直接回到绑定钱包。提现时 TON 网络会收取自己的 gas 费。',
  'coinflip.info.verify_dont_trust_title': '自己验证，不必盲信',
  'coinflip.info.verify_dont_trust_body': '每一局结果都由我们的服务用 HMAC-SHA256 签名，输入为 (server_seed, client_seed, nonce, choice)。打开“验证”页，粘贴任意对局 ID，你的浏览器就会重新计算结果。如果我们说谎，重新计算的结果就不会匹配。',
  'coinflip.info.why_title': '我们为什么这样做？',
  'coinflip.info.why_body': '因为龙虎斗只是起点。我们正在打造一个更透明的游戏平台，而赢得你信任的最好方式，就是从设计上做到可验证公平，让每一局都能核验。当我们从第一天起就建立在透明之上，想象一下未来注额更高时我们能做成什么。',
  'coinflip.info.dismiss_btn': '明白了 — 开始下注',
  'deposit.custodial_tooltip': '托管模式：你的 TON 由CricketFlip保管，并按请求提现。',
  'deposit.error.maintenance': '充值因维护暂时暂停。请几分钟后重试。',
  'deposit.error.unconfigured': '充值暂时不可用。请通过菜单里的「发送反馈」告诉我们。',
  'deposit.error.invoice_failed': '无法创建充值发票。请稍后重试。',
  'deposit.error.invoice_invalid': '服务器返回了无效的充值发票。请稍后重试。',
  'deposit.error.tx_failed_pre_wallet': '交易失败。请重试 — 你的 TON 仍在你的钱包中。',
  'deposit.title': '充值 TON',
  'deposit.subtitle': '一次批准。TON 进入你的CricketFlip余额。',
  'deposit.custom_amount_placeholder': '或输入金额',
  'deposit.custom_amount_aria': '自定义 TON 充值金额',
  'deposit.amount_label': '金额',
  'deposit.quick_amounts_label': '快捷金额',
  'deposit.summary_deposit_label': '充值',
  'deposit.summary_amount': '{amount} TON',
  'deposit.network_fee_note': '你的钱包会另行支付少量 TON 网络费（支付给验证者）。',
  'deposit.confirm_btn': '充值 {amount} TON',
  'deposit.confirm_btn_empty': '输入金额',
  'deposit.preparing_title': '正在准备你的充值...',
  'deposit.preparing_sub': '正在生成一次性发票',
  'deposit.approve_title': '在 Tonkeeper 中批准',
  'deposit.approve_sub': '请在钱包中确认充值交易',
  'deposit.confirming_title': '正在链上确认...',
  'deposit.confirming_wait_early': '正在等待网络确认你的充值...',
  'deposit.confirming_wait_mid': '仍在确认中 — 这在 TON 上是正常的...',
  'deposit.confirming_wait_late': '快好了 — 今天网络有点慢...',
  'deposit.confirming_safe_note': '💎 你的 TON 是安全的。我们看到充值到账后会立即记入余额。',
  'deposit.done_title': '充值成功！',
  'deposit.done_credited': '{amount} TON 已记入你的余额',
  'deposit.delayed_title': '等待确认',
  'deposit.delayed_body': '你已在钱包中批准交易，交易正在路上。我们仍在等待网络确认 — TON 可能需要几分钟。到账后我们会自动记入你的余额。',
  'deposit.delayed_invoice': '发票：{invoiceId}',
  'deposit.check_again_btn': '再次检查',
  'deposit.delayed_no_resend': '💎 不要再次发送充值 — 这笔充值已经在路上。',
  'deposit.error_funds_safe_note': '在我们链上确认之前，你的 TON 仍留在你的钱包中。没有资金丢失。',
  'emergency.status.constructing': '正在构建交易...',
  'emergency.status.confirm_wallet': '请在钱包中确认...',
  'emergency.status.force_close_sent': '✅ 强制关闭交易已发送。7 天挑战窗口结束后结算。窗口结束后请回来点击「完成结算」完成提现。',
  'emergency.status.force_close_error': '❌ 交易失败。请重试。',
  'emergency.status.constructing_finalize': '正在构建 finalize 交易...',
  'emergency.status.finalize_sent': '✅ 结算确认已发送。如果资金池充足，你的 TON 会很快到账；如果不足，你的通道会进入 CLAIM_PENDING — 资金池补足后自动结算。',
  'emergency.status.finalize_error': '❌ 结算确认失败。7 天挑战窗口可能尚未结束。',
  'emergency.header': '服务器离线 — 可用强制关闭',
  'emergency.subtitle': '信任最小化的逃生路径。提交你持有的收据；7 天挑战窗口后结算。请在运营方无响应时使用。',
  'emergency.balance_label': '你的余额（来自最新收据）',
  'emergency.channel_nonce': '通道 #{channelId} · Nonce {nonce}',
  'emergency.btn.sending': '正在发送...',
  'emergency.btn.force_close': '强制关闭通道',
  'emergency.btn.finalize': '完成结算（7 天挑战窗口后）',
  'emergency.no_receipts': '此浏览器中没有可用收据。如果你是在另一台设备上玩的，收据存储在那里。服务器会很快恢复。',
  'emergency.footer_note': '基于收据的强制关闭。在极端资金池条件下，结算可能记录为 CLAIM_PENDING，并在资金池补足后自动结算。申领不会过期。',
  'error_boundary.title': '出了点问题',
  'error_boundary.body': '你的会话和余额是安全的。界面遇到意外错误，无法继续渲染。请重新加载以重新开始。',
  'error_boundary.reload_btn': '重新加载',
  'error_boundary.contact_note': '如果问题持续发生，请通过 Telegram 频道联系我们，我们会查看。',
  'error_boundary.tech_details_summary': '技术详情',
  'feedback.error.submit_failed': '无法发送反馈。请稍后再试。',
  'feedback.success_title': '谢谢 — 每一条我们都会读',
  'feedback.success_body': '你的反馈已收到。我们不会通过此表单回复。',
  'feedback.title': '反馈',
  'feedback.intro': '发现 bug 或有建议？告诉我们。每条提交我们都会阅读。',
  'feedback.rating_prompt': '你的体验如何？',
  'feedback.star_aria_singular': '{n} 星',
  'feedback.star_aria_plural': '{n} 星',
  'feedback.stars_count': '{stars}/5',
  'feedback.message_label': '留言（可选）',
  'feedback.char_counter': '{charCount}/{charLimit}',
  'feedback.message_placeholder': 'Bug 报告、功能建议或其他内容...',
  'feedback.safety_reminder': '🔐 永远不要分享你的助记词、私钥或恢复词。我们永远不会索要这些信息。',
  'feedback.submit_btn_loading': '正在发送...',
  'feedback.submit_btn': '发送反馈',
  'header_menu.support.copied_toast': '已复制 · {SUPPORT_EMAIL}',
  'header_menu.more_options_aria': '更多选项',
  'header_menu.how_it_works': '玩法说明',
  'header_menu.send_feedback': '发送反馈',
  'header_menu.terms': '条款',
  'header_menu.privacy': '隐私',
  'header_menu.support': '支持',
  'history.entry.deposit': '充值',
  'history.entry.flip': '对局',
  'history.entry.won': '赢局',
  'history.entry.withdrawal': '提现',
  'history.entry.withdrawal_reversed': '提现已冲正',
  'history.entry.deposit_reversed': '充值已冲正',
  'history.entry.refund': '退款',
  'history.load_error.title': '无法加载你的活动记录',
  'history.load_error.body': '我们刚刚无法连接服务器。请刷新，或稍后再查看。',
  'history.data_error.title': '服务器返回了格式异常的账本数据',
  'history.data_error.body': '我们不会显示部分或可能不正确的活动记录。请刷新；如果持续发生，请通过菜单里的「发送反馈」告诉我们。',
  'history.loading': '正在加载...',
  'history.stats.flips': '对局数',
  'history.stats.win_rate': '胜率',
  'history.stats.profit': '盈亏',
  'history.verify_hint': '点击下方任意对局记录，即可进行加密验证。',
  'history.empty.title': '还没有活动记录',
  'history.empty.body': '充值 TON 并完成第一局后，你的历史记录会从这里开始。',
  'history.amount_invalid': '无效',
  'history.flip.bet_context': '· 下注 {stakeStr}',
  'history.row.ton_verify': 'TON · 验证 →',
  'history.row.verify_aria': '验证对局 {refId}',
  'history.row.flip_aria': '{label} {headText} TON',
  'history.row.entry_aria': '{label} {sign}{tonStr} TON，时间 {timestamp}',
  'history.feedback_footer': '发现 bug 或有反馈？发送给我们 →',
  'leaderboard.placeholder.title': '排行榜即将回归',
  'leaderboard.placeholder.body': '我们正在为托管模式重建排行榜。你的标准档对局会继续累计在活动账本中 — 排行榜重新开启后，每一局都会计入。',
  'leaderboard.coming_back': '即将回归',
  'leaderboard.equal_odds.title': '每一局机会均等',
  'leaderboard.equal_odds.body': '排行榜重新开启后，将反映终身账本活动。',
  'onboarding.slide1.title': 'TON 龙虎斗，即时派奖',
  'onboarding.slide1.desc': '选择龙或虎下注。标准档获胜赔付你下注额的 2×；输了则失去注额。黄金和钻石档赔付更高，但会收取一笔小费用，费用会提前显示。就这么简单。',
  'onboarding.slide1.highlight': '标准档 2× · 黄金/钻石赔付更高',
  'onboarding.slide2.title': '随时提现',
  'onboarding.slide2.desc': '你的余额属于你。想什么时候提现都可以，一键将全部余额提到绑定钱包 — TON 网络提现 gas 费另计。',
  'onboarding.slide2.highlight': '你的余额，由你掌控',
  'onboarding.slide3.title': '可验证公平',
  'onboarding.slide3.desc': '连接钱包即可使用真实 TON 游玩。每一局结果都会由我们的服务签名，方便你验证。任意一局都可自行验证。',
  'onboarding.slide3.highlight': '连接钱包 · 每一局都可验证',
  'onboarding.skip': '跳过',
  'onboarding.next': '下一步',
  'onboarding.start': '开始下注 ⚡',
  'settlement.open.label': '通道已打开',
  'settlement.open.description': '可以开始游玩。随时点击提现来结算你的余额。',
  'settlement.cooperative_closing.label': '正在提现 — 正在结算',
  'settlement.cooperative_closing.description': '使用你的当前余额进行运营方协助的快速结算。',
  'settlement.force_closing.label': '强制关闭进行中',
  'settlement.force_closing.description': '7 天挑战窗口结束后结算。',
  'settlement.claim_pending.label': '赢局已链上记录。等待资金池补足后派奖。',
  'settlement.claim_pending.description': '正在自动重试。',
  'settlement.countdown.expired': '挑战窗口已结束',
  'settlement.countdown.days_hours': '剩余 {days} 天 {hours} 小时',
  'settlement.countdown.hours_minutes': '剩余 {hours} 小时 {minutes} 分钟',
  'settlement.countdown.minutes_seconds': '剩余 {minutes} 分钟 {seconds} 秒',
  'settlement.countdown.seconds': '剩余 {seconds} 秒',
  'settlement.unknown_state': '未知状态（{state}）',
  'verify.error.invalid_uuid': '对局 ID 必须是有效 UUID（例如 6f5a8b3c-1d2e-4a4f-9c0d-1234567890ab）。',
  'verify.error.not_found': '找不到对局 {id}，或它不属于你。',
  'verify.error.fetch_failed': '无法验证这一局。请检查连接后重试。',
  'verify.title': '可验证公平',
  'verify.subtitle': '验证任意一局 — 计算在你的浏览器中运行，而不是在我们这里',
  'verify.input.placeholder': '粘贴对局 ID（UUID）',
  'verify.button.verify': '验证',
  'verify.status.pending_body': '这一局仍在结算中。server_seed 还没有公开 — 请稍后再查看。',
  'verify.status.failed_body': '这一局在结算前失败。没有扣除资金。',
  'verify.status.failed_refunded_body': '这一局在结算时失败；注额已退回到你的余额。',
  'verify.commit_hash_prebet_label': 'Commit hash（下注前）',
  'verify.result.picked_result': '选择：{choice} · 结果：{outcome}',
  'verify.error.invalid_stake': '服务器返回的注额无效',
  'verify.status.valid_badge': '✓ 有效',
  'verify.status.mismatch_badge': '✗ 不匹配',
  'verify.status.matches_badge': '✓ 匹配',
  'verify.step1.title': '承诺完整性',
  'verify.step1.sha256_label': 'SHA-256(server_seed)',
  'verify.step1.precommitted_label': '预先承诺的 commit_hash',
  'verify.step1.valid_msg': '✓ Server seed 与我们在本局开始前承诺的哈希一致。',
  'verify.step1.mismatch_msg': '✗ 哈希不匹配 — server_seed 与预承诺不一致！',
  'verify.step2.title': 'HMAC-SHA256',
  'verify.step2.server_seed_label': 'Server seed（key + msg[0..31]，32 B）',
  'verify.step2.client_seed_label': 'Client seed（msg[32..63]，32 B）',
  'verify.step2.nonce_label': 'Nonce（msg[64..71]，uint64 BE）',
  'verify.step2.choice_label': 'Choice（msg[72]）',
  'verify.step2.recomputed_label': 'HMAC-SHA256（在你的浏览器中重新计算）',
  'verify.step2.backend_hmac_label': '后端声称的 HMAC',
  'verify.step2.valid_msg': '✓ HMAC 匹配 — 结果由四个公开输入确定。',
  'verify.step2.mismatch_msg': '✗ HMAC 不匹配 — 重新计算结果与后端不一致！',
  'verify.step3.title': '结果',
  'verify.step3.hmac_lowbit': 'hmac[0] = 0x{hex} · 低位 = {bit}',
  'verify.step3.bit_mapping': '0 → {heads}\n1 → {tails}',
  'verify.step4.title': '自行验证',
  'verify.step4.run_instruction': '在已安装 Node.js 的任意终端中运行：',
  'verify.copy.copied': '✅ 已复制！',
  'verify.copy.default': '📋 复制证明',
  'verify.explainer.summary': '我看到的是什么？',
  'verify.explainer.step_label': '步骤 {n} — {title}：',
  'verify.explainer.step1_body': '服务器会在你提交本局下注之前，先选取一个 32 字节的随机 server_seed，并公布 SHA-256(server_seed) 作为 commit_hash。本局结算后，我们会公开 server_seed；此时 SHA-256(server_seed) 必须仍等于那个预先承诺的 commit_hash。若一致，就说明种子不是事后才挑选的。',
  'verify.explainer.step2_body': '结果 = HMAC-SHA256(key = server_seed, message = server_seed ‖ client_seed ‖ nonce ‖ choice)。client_seed 由你提供，server_seed 由服务器提供，nonce 在请求本局时即已锁定。相同的四个输入永远会产生相同的 HMAC；你的浏览器刚刚重新算了一遍。',
  'verify.explainer.step3_body': 'HMAC 第一个字节的最低位决定结果为龙（0）还是虎（1）。这个计算完全由上面四个输入决定；没有任何其他随机来源。',
  'verify.explainer.step4_body': '在任意机器上运行这个 Node 命令，你会得到完全相同的 HMAC 十六进制值。运行该命令不需要连接任何 CricketFlip 服务器。',
  'verify.howitworks.header': '可验证公平如何运作',
  'verify.howitworks.step1_title': '我们会在本局下注前承诺一个 server seed',
  'verify.howitworks.step2_title': '你提交自己的 client seed',
  'verify.howitworks.step3_title': '结果 = HMAC-SHA256(seed, msg)',
  'verify.howitworks.step4_title': '任何人都可以永久重新计算',
  'verify.howitworks.step1_desc': '系统会生成一个 32 字节的随机 server_seed，并公布 SHA-256(server_seed) 作为 commit_hash。你一点击「下注」，该哈希便被锁定；之后我们无法再更改种子。',
  'verify.howitworks.step2_desc': '你的浏览器会在下注时生成一个 32 字节的 client_seed，并连同你的选择一起发送。随机性有一半由你掌控；我们无法预测你会发送什么。',
  'verify.howitworks.step3_desc': '以 server_seed 为密钥，对 (server_seed ‖ client_seed ‖ nonce ‖ choice) 计算 HMAC。byte[0] 的最低位就是你的结果。完全确定，没有任何隐藏随机性。',
  'verify.howitworks.step4_desc': '结算后我们会公开 server_seed。你的浏览器会重新计算 SHA-256 + HMAC，并把结果展示给你。一致 = 诚实；不一致 = 当场发现问题。',
  'verify.tagline': '从设计上可验证公平的龙虎对局',
  'deposit.amount_error.too_precise': '最多 9 位小数',
  'deposit.amount_error.invalid_amount': '请输入有效的 TON 金额',
  'deposit.amount_error.below_min': '最低充值为 {min} TON',
  'deposit.amount_error.above_max': '最高充值为 {max} TON',
  'cta.flip_standard': '下注 {stake} TON',
  'cta.flip_boost_mega': '{prefix} {label} +{fee} → 赢取 {win} TON',
  'cta.base_summary': '下注 {stake} → 赢取 {stake_x2} TON',
  'error.session_timeout_title': '需要重新连接',
  'error.session_timeout_message': '你的安全会话已超时。请从 Telegram 重新打开CricketFlip以继续。',
  'legal.english_controlling_notice': '本页面仅提供英文版本。英文版本为具有约束力的版本。',
  'tier.standard': '标准',
  'tier.boost': '黄金',
  'tier.mega': '钻石',
  'withdraw.confirm.title': '提现',
  'withdraw.confirm.you_receive': '你将收到',
  'withdraw.confirm.balance_ton': '{amount} TON',
  'withdraw.confirm.to_your_wallet': '到你的钱包',
  'withdraw.confirm.no_fees': '全额余额 — 不扣除手续费',
  'withdraw.confirm.cta': '提现 {amount} TON',
  'withdraw.processing.title': '正在提现...',
  'withdraw.processing.queueing': '正在排队处理你的提现...',
  'withdraw.processing.submitting': '正在提交链上交易...',
  'withdraw.processing.awaiting_confirmation': '等待确认...',
  'withdraw.processing.reassurance': '你的 TON 是安全的，正在前往你的钱包。',
  'withdraw.queued.title': '提现进行中',
  'withdraw.queued.result_msg': '你的提现正在处理中 — 可随时在“记录”中追踪。',
  'withdraw.queued.footer': '可随时在“记录”中查看提现进度。',
  'withdraw.review.title': '正在路上！',
  'withdraw.review.result_msg': '你的提现正在发往你的钱包 🚀',
  'withdraw.success.title': '提现已发送',
  'withdraw.success.result_msg': '{amount} TON 已发送到你的钱包',
  'withdraw.success.explorer_link': '在 TON Explorer 查看 →',
  'withdraw.success.footer': '已直接发送到你的绑定钱包。',

  // ── CF-BONUS-V3-WITHDRAW-WARNING-V1 ────────────────────────────────────────
  // 在奖金有效期内提现，后端会在同一笔交易中作废奖金，且不可恢复。此前应用内没有任何提示。
  'withdraw.bonus.at_risk_label': '你的奖金筹码',
  'withdraw.bonus.forfeit_warning': '你还有 {amount} TON 奖金筹码，现在提现会关闭它们。',
  'withdraw.bonus.unlock_hint': '再进行 {amount} TON 的 Boost 或 Mega 投注，就能把它们变成真实余额。',
  'withdraw.bonus.keep_cta': '继续游戏',
  'withdraw.bonus.forfeit_cta': '仍要提现',
  'withdraw.bonus.checking': '正在查询你的奖金…',
  'withdraw.bonus.blocked_title': '暂时无法查询你的奖金',
  'withdraw.bonus.blocked_body': '此时提现可能在没有提示的情况下作废奖金筹码，因此我们暂停了提现。你的余额未受影响 — 请稍后重试。',
  'withdraw.bonus.retry': '重试',
  'withdraw.error.title': '提现未完成',
  'withdraw.error.reassurance': '你的余额安全 — 请再试一次；如果持续发生，请通过菜单里的「发送反馈」告诉我们。',
  'withdraw.error.failed_default': '提现失败。你的余额安全。',
  'withdraw.error.reversed': '提现未能送达，金额已退回到你的余额。',
  'withdraw.error.network': '网络错误。你的余额安全 — 请重试。',
  'withdraw.error.missing_id_accepted': '你的提现已受理。如果需要我们核对追踪详情，请通过菜单里的「发送反馈」告诉我们。',
  'withdraw.error.maintenance_mode': '提现因维护暂时暂停。请几分钟后重试。',
  'withdraw.error.insufficient_balance': '本次提现余额不足。',
  'withdraw.error.temporary_insolvency_protection': '我们现在无法处理这笔提现 — 你的余额完全安全。请几分钟后重试。',
  'withdraw.error.invalid_dest_address': '目标钱包不是有效的 TON 地址。',
  'withdraw.error.hot_wallet_balance_unavailable': '网络短暂波动 — 请再次点击提现。你的余额安全。',
  'withdraw.error.hot_wallet_unconfigured': '提现暂时不可用。请稍后再试。',
  'withdraw.error.invalid_request': '提现请求无效。请重试。',
  'withdraw.balance_invalid.title': '现在无法显示你的余额',
  'withdraw.balance_invalid.body': '你的资金安全 — 我们只是暂时无法读取可靠的可提现余额。请关闭此窗口并从首页重试。如果持续发生，请通过菜单里的「发送反馈」告诉我们。',

  // ── CF-BONUS Ticket B — 首次充值奖金 ────────────────────────────────────────
  // ⛔ 档位名称：本版本中 tier.boost = 黄金、tier.mega = 钻石。条款里必须使用
  // 「黄金」「钻石」，绝不能写 Boost / Mega — 否则玩家读到的档位名与界面上的
  // 不一致，会把符合条件的投注押在错误的档位上，从而失去奖金。
  // 本翻译必须保留：D1（提现会取消剩余筹码）、D2（转换上限为已发放奖金）、
  // 仅黄金/钻石计入、费用说明、可用性并非保证、以及「符合条件的」充值。
  'bonus.teaser.headline': '首充 100% 奖金，最高 10 TON',
  'bonus.teaser.body': '你的首次充值将以等额奖金筹码翻倍，最高 10 TON。须满足投注条件。',
  'bonus.teaser.availability': '资格与可用性将在你的充值入账时确认。',
  'bonus.teaser.terms_link': '奖金条款',

  'bonus.terms.title': '首充 100% 奖金，最高 10 TON',
  'bonus.terms.pt1': '完成你的首次充值，即可获得等额奖金筹码，最高 10 TON。例如：充值 5 TON，额外获得 5 TON 奖金筹码。',
  'bonus.terms.pt2': '奖金筹码是游戏额度：下注时会优先使用它们，然后才动用你自己的资金。它们不能直接提现。',
  'bonus.terms.pt3': '要解锁现金转换，需在黄金档或钻石档投注达到奖金金额的 10 倍 — 只有这两个档位计入，并且照常收取各自的费用。例如：10 TON 奖金需要 100 TON 的黄金或钻石投注。',
  'bonus.terms.pt4': '达成投注要求后，你剩余的奖金筹码 — 包括由这些筹码赢得的奖金 — 将转换为可提现余额，上限为已发放的奖金金额。超出你原始奖金金额的部分将在转换时作废：可转为现金的最高额度就是你获得的奖金。如果你输掉筹码、在达到 10 倍前停止，或七天期限届满，你可能得不到任何现金转换。',
  'bonus.terms.pt5': '奖金不会锁定你自己的资金。但在投注要求完成之前提现，会取消你剩余的奖金筹码 — 它们将在那一刻作废。',
  'bonus.terms.pt6': '奖金在发放后 7 天到期。未使用的奖金筹码将在到期时移除。',
  'bonus.terms.pt7': '每位玩家、每个钱包仅限一次奖金，且仅适用于你已确认并与账单匹配的首次充值。来自此前已充值过的钱包（无论使用哪个账户）的充值不符合条件。',
  'bonus.terms.pt8': '在奖金名额尚有余量期间，你会看到该优惠。资格与可用性将在你的充值入账时确认；无论是否发放奖金，你符合条件的充值都会全额入账。',
  'bonus.terms.pt9': '我们可能随时暂停或结束新奖金的发放活动。已经发放的奖金将保留其全部条款。',

  'bonus.active.title': '你的奖金',
  'bonus.active.chips_label': '奖金筹码',
  'bonus.active.chips_note': '下注时优先使用，然后才动用你自己的资金。',
  'bonus.active.progress_label': '投注进度',
  'bonus.active.progress_detail': '黄金或钻石档已投注 {done} / {target} TON',
  'bonus.active.remaining': '还需 {amount} TON 的黄金或钻石投注即可解锁转换',
  'bonus.active.complete': '投注要求已完成',
  'bonus.active.expires_in': '{time}后到期',
  'bonus.active.expired_note': '此奖金已到达到期时间。',

  'bonus.time.days_hours': '{days} 天 {hours} 小时',
  'bonus.time.hours_mins': '{hours} 小时 {mins} 分',
  'bonus.time.mins': '{mins} 分',

  'bonus.terminal.converted_title': '奖金已完成',
  'bonus.terminal.converted_body': '{amount} TON 已转换为可提现余额。',
  'bonus.terminal.converted_zero': '此奖金已结束，未产生现金转换。',
  'bonus.terminal.expired_title': '奖金已过期',
  'bonus.terminal.expired_body': '7 天期限已届满，剩余的奖金筹码已被移除。',
  'bonus.terminal.voided_title': '奖金已结束',
  'bonus.terminal.voided_body': '你在完成投注要求之前提现，因此剩余的奖金筹码已被取消。',

  // A1：读取失败是「我们不知道」，绝不是「你没有奖金」。也不声称筹码仍然完好。
  'bonus.unavailable.title': '奖金状态暂时无法显示',
  'bonus.unavailable.body': '我们现在无法加载你的奖金状态。这只是显示问题 — 读取状态永远不会改变它。请稍后再试。',
  'growth.ticker.win': '有玩家刚刚赢得 {amount} TON',
};
